<template>
  <div>
    <b-skeleton-wrapper :loading="!selectedTab">
      <template #loading>
        <b-row class="my-3">
          <b-col>
            <b-skeleton width="50%" height="40px" />
          </b-col>
          <b-col class="d-flex justify-content-end">
            <b-skeleton width="30%" height="40px" />
          </b-col>
        </b-row>
        <b-card class="p-4">
          <b-row class="my-3">
            <b-col>
              <b-skeleton width="50%" height="40px" />
            </b-col>
            <b-col class="d-flex justify-content-end">
              <b-skeleton width="30%" height="40px" />
            </b-col>
          </b-row>
          <b-skeleton width="100%" height="300px" />
        </b-card>
      </template>

      <div class="row">
        <div class="col-12">
          <!-- Table -->
          <div class="table-responsive m-3">
            <McGrapqlTable
              :isLoading="loading"
              :apiClient="query"
              :fields="fields"
              :customHandlers="customHandlers"
              :hasCheckbox="true"
              :searchable="true"
              :withCard="true"
              :isSelectableField="false"
              trackBy="serviceId"
              :isEmpty="services.length == 0"
              :busy="isDuplicate"
              :refreshData="!loading"
              customButton
            >
              <template #title>
                <h4>{{ $t('maintenance.hourmeter.serviceSchedule') }}</h4>
              </template>

              <template #button-header>
                <McButton
                  v-if="!hasVehicle"
                  variant="secondary"
                  text="Template"
                  icon="icon-outline_file"
                  class="me-2 mb-2"
                  @click="handleOpenModal"
                />
              </template>

              <template #tab-button>
                <div class="mc-btn--tab">
                  <b-form-radio-group
                    id="tab-service-schedule"
                    v-model="selectedTab"
                    :options="tabOptions"
                    name="tab-service-schedule"
                    buttons
                    @change="refreshTable"
                  ></b-form-radio-group>
                </div>
              </template>

              <template #cell(intervalTime)="data">
                {{ data.value }} {{ checkValue(data.item.intervalPeriod) }}
              </template>

              <template #cell(intervalHourmeter)="data">
                {{ minuteToHour(data.value) }}
              </template>

              <template #cell(intervalRefrigerator)="data">
                {{ minuteToHour(data.value) }}
              </template>

              <template #emptyState>
                <McEmptyState
                  :title="$t('maintenance.nolist.title')"
                  :desc="$t('maintenance.nolist.desc')"
                  buttonTextSecondary="Template"
                  buttonIconSecondary="icon-outline_file"
                  @buttonPrimaryAction="customHandlers.handleAdd"
                  @buttonSecondaryAction="handleOpenModal"
                  class="pb-4"
                  :isDisabled="isDuplicate"
                ></McEmptyState>
              </template>
            </McGrapqlTable>
          </div>
        </div>
      </div>
    </b-skeleton-wrapper>
    <ModalTemplate ref="modalTemplateRef" @handleSubmitTemplate="handleTemplate" />
  </div>
</template>
<script>
import appConfig from '@/app.config'
import { Helper } from '@/mixin/helper'
import McGrapqlTable from '@/components/McGrapqlTable'
import { mapGetters } from 'vuex'
import McEmptyState from '@/components/McEmptyState'
import McButton from '@/components/McButton'
import ModalTemplate from './ModalTemplate.vue'
import {
  GET_SERVICES_2_SSGROUP,
  DELETE_SERVICE_2_SSGROUP,
  CREATE_SERVICE_2_SSGROUP_BY_TEMPLATE,
} from '@/services/api/maintenance/ssgroup'

/**
 * Starter component
 */
export default {
  page: {
    title: 'Servis',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    McGrapqlTable,
    McEmptyState,
    McButton,
    ModalTemplate,
  },

  mixins: [Helper],

  apollo: {
    services2Ssgroup: {
      query: GET_SERVICES_2_SSGROUP,
      fetchPolicy: 'no-cache',
      variables() {
        return {
          filter: {
            ssgroupId: [Number(this.$route.params.ssgroupId)],
            type: ['DistanceAndTime', 'Hourmeter', 'Refrigerator'],
            pagination: {
              page: 1,
              show: 99999,
            },
          },
        }
      },
      result({ data, loading }) {
        if (loading) {
          return
        }

        const services = data.services2Ssgroup.services2Ssgroup.data
        this.services = services

        const kilometerData = services.filter((item) => item.type === 'DistanceAndTime')
        const hourmeterData = services.filter((item) => item.type === 'Hourmeter')
        const refrigeratorData = services.filter((item) => item.type === 'Refrigerator')

        this.kilometerData = kilometerData.length
        this.hourmeterData = hourmeterData.length
        this.refrigeratorData = refrigeratorData.length

        if (this.kilometerData > 0) this.selectedTab = 'DistanceAndTime'
        else if (this.hourmeterData > 0) this.selectedTab = 'Hourmeter'
        else if (this.refrigeratorData > 0) this.selectedTab = 'Refrigerator'
        else this.selectedTab = 'DistanceAndTime'
      },
    },
  },

  props: ['isDuplicate', 'hasVehicle'],

  data() {
    return {
      customHandlers: {
        handleAdd: () => {
          return this.$router.push({
            name: 'Add Component Schedule',
          })
        },
        handleClickRow: (item) => {
          return this.$router.push({
            name: 'Detail Component Schedule',
            params: { ssgroupId: item.ssgroupId, serviceId: item.serviceId },
          })
        },
      },
      services: [],
      selectedTab: '',
      loading: false,
      kilometerData: 0,
      hourmeterData: 0,
      refrigeratorData: 0,
    }
  },

  computed: {
    ...mapGetters({
      getFeatureFlagValue: 'identity/getFeatureFlagValue',
    }),
    isMGMAndMO() {
      const data = this.getFeatureFlagValue('customFeature.mgm')
      return (
        Array.isArray(data?.company_id) &&
        data.company_id.includes(this.getCompanyId()) &&
        data.features?.maintenance_order
      )
    },
    title() {
      return this.$t('maintenance.detailSchedule.title')
    },

    tabOptions() {
      const tabs = [
        (this.kilometerData > 0) && {
          text: `${this.$t('maintenance.hourmeter.kilometerTime')} (${this.kilometerData})`,
          value: 'DistanceAndTime',
        },
        (this.hourmeterData > 0) && {
          text: `${this.$t('maintenance.hourmeter.workingHours')} (${this.hourmeterData})`,
          value: 'Hourmeter',
        },
        (this.isMGMAndMO && this.refrigeratorData > 0) && {
          text: `${this.$t('maintenance.form.refrigerator')} (${this.refrigeratorData})`,
          value: 'Refrigerator',
        },
      ].filter(Boolean)

      return tabs.length > 1 ? tabs : []
    },

    optionalFields() {
      let field = []

      if (this.selectedTab === 'DistanceAndTime') {
        field = [
          {
            key: 'intervalDistance',
            label: this.$t('maintenance.form.intKm'),
            isSortable: false,
            formatter: (val) => {
              return this.thousandFormat(val)
            },
          },
          {
            key: 'intervalTime',
            label: this.$t('maintenance.form.intTime'),
            isSortable: false,
          },
        ]
      } else if (this.selectedTab === 'Hourmeter') {
        field = [
          {
            key: 'intervalHourmeter',
            label: this.$t('maintenance.hourmeter.interval'),
            isSortable: false,
          },
        ]
      } else if (this.selectedTab === 'Refrigerator') {
        field = [
          {
            key: 'intervalRefrigerator',
            label: this.$t('maintenance.refrigerator.interval'),
            isSortable: false,
          },
        ]
      }
      return field
    },

    fields() {
      return [
        {
          key: 'service',
          label: this.$t('maintenance.field.compName'),
          isSortable: false,
          isRedirectable: true,
          formatter: (val, key, item) => {
            return `${item.service.name} (${item.service.serviceAction.action})`
          },
        },
        {
          key: 'service.serviceCategory.name',
          label: this.$t('maintenance.form.catService'),
          isSortable: false,
        },
        {
          key: 'method',
          label: this.$t('maintenance.field.method'),
          isSortable: false,
        },
        ...this.optionalFields,
      ]
    },

    query() {
      return {
        get: async (filter) => {
          return this.get(filter)
        },

        delete: async (filter) => {
          const res = await this.$apollo.mutate({
            mutation: DELETE_SERVICE_2_SSGROUP,
            variables: {
              input: {
                type: this.selectedTab,
                serviceId: filter,
                ssgroupId: Number(this.$route.params.ssgroupId),
              },
            },
          })

          if (res.data.deleteService2Ssgroup.isSuccessful) {
            const self = this
            self.refreshTable()
            self.$apollo.queries.services2Ssgroup.refetch({
              filter: {
                ssgroupId: [Number(this.$route.params.ssgroupId)],
                type: ['DistanceAndTime', 'Hourmeter', 'Refrigerator'],
              },
            })

            self.$emit('refreshData')
          }
          return res.data.deleteService2Ssgroup.isSuccessful
        },
      }
    },
    ...mapGetters({
      isWhitelabel: 'identity/isWhitelabel',
      isMetrack: 'identity/isMetrack',
    }),

    illustrationPath() {
      if (this.isWhitelabel() || this.isMetrack()) {
        return require(`@/assets/images/illustration/whitelabel/no-data.svg`)
      }
      return require(`@/assets/images/illustration/saas/no-data.svg`)
    },
  },

  methods: {
    async get(filter) {
      const res = await this.$apollo.query({
        query: GET_SERVICES_2_SSGROUP,
        fetchPolicy: 'no-cache',
        variables: {
          filter: {
            ...filter,
            type: this.selectedTab,
            ssgroupId: [Number(this.$route.params.ssgroupId)],
          },
        },
      })

      return res.data.services2Ssgroup.services2Ssgroup
    },

    checkValue(data) {
      switch (data) {
        case 'd':
          return this.$t('global.time.day')
        case 'w':
          return this.$t('global.time.week')
        case 'm':
          return this.$t('global.time.month')

        default:
          break
      }
    },

    refreshTable() {
      this.loading = true
      const tab = this.selectedTab
      this.selectedTab = ''

      setTimeout(() => {
        const availableTabs = [
          this.kilometerData > 0 ? 'DistanceAndTime' : null,
          this.hourmeterData > 0 ? 'Hourmeter' : null,
          (this.isMGMAndMO && this.refrigeratorData > 0) ? 'Refrigerator' : null,
        ].filter(Boolean)

        this.selectedTab = availableTabs.includes(tab) ? tab : availableTabs[0]
        this.loading = false
      }, 1000)
    },
    handleOpenModal() {
      this.$bvModal.show('modal-template')
    },
    async handleTemplate(templateId) {
      const input = {
        ssgroupId: Number(this.$route.params.ssgroupId),
        templateId: templateId,
      }

      const res = await this.$apollo.mutate({
        mutation: CREATE_SERVICE_2_SSGROUP_BY_TEMPLATE,
        variables: {
          input: input,
        },
      })

      if (res.data.createServices2Ssgroup.isSuccessful) {
        this.$mcToast.success('Berhasil')
      } else {
        this.$mcToast.error(res.data.createServices2Ssgroup.message)
      }

      this.$bvModal.hide('modal-template')
      this.refreshTable()
      this.$apollo.queries.services2Ssgroup.refetch({
        filter: {
          ssgroupId: [Number(this.$route.params.ssgroupId)],
          type: ['DistanceAndTime', 'Hourmeter', 'Refrigerator'],
        },
      })

      this.$emit('refreshData')
    },
  },
}
</script>
